import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { LabelAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/label-answer-config.model';
import { EdlCfGenericModel, EdlCfLabelModel, MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfLabelMapperService implements IPaetepCfGenericMapperService<LabelAnswerConfig, EdlCfLabelModel> {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<LabelAnswerConfig>): EdlCfLabelModel => {
        return {
            title: child.label,
            description: child.answerConfig?.labelText ?? ''
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfLabelModel>
    }): CustomFormQuestionDisplayDTO<LabelAnswerConfig> =>  {
        return this.customFormsHelpersService.createCustomFormQuestion<LabelAnswerConfig>({
            formID,
            sectionID,
            questionID: question?.id ?? '',
            $type: CustomFormQuestionType.LABEL,
            typeID: CustomFormQuestionType.LABEL,
            readOnly: false,
            required: false,
            displayOrder,
            groupOrder,
            label: (question?.config?.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                labelText: (question.config.description ?? '').substring(0, MAX_DESCRIPTION_LENGTH)
            }
        });
    }
}
